<ng-template appRibbonToolbarContent></ng-template>
<ng-template appRibbonDialogContent></ng-template>
